import { render, staticRenderFns } from "./LuckyRule.vue?vue&type=template&id=54f875f6&scoped=true&"
import script from "./LuckyRule.vue?vue&type=script&lang=js&"
export * from "./LuckyRule.vue?vue&type=script&lang=js&"
import style0 from "./LuckyRule.vue?vue&type=style&index=0&id=54f875f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f875f6",
  null
  
)

export default component.exports